import { render, staticRenderFns } from "./OrderInstallPage.vue?vue&type=template&id=efc9f96e&scoped=true&"
import script from "./OrderInstallPage.vue?vue&type=script&lang=js&"
export * from "./OrderInstallPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc9f96e",
  null
  
)

export default component.exports